import {GET_ALL_FAVOURITE_PROPERTIES,GET_ALL_REPORTED_PROPERTIES} from "../actions/types";

const initialState = {
    favourite: {
      docs: [],
      totalDocs: 0,
      limit: 0,
      page: 0,
      totalPages: 0,
      pagingCounter: 0,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
    },
    reported: {
      docs: [],
      totalDocs: 0,
      limit: 0,
      page: 0,
      totalPages: 0,
      pagingCounter: 0,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
    },
    loading: true,
    // propertyData: {},
  };

  const getFavouritePropertiesReducer=(state=initialState,{type,payload})=>{
    switch(type){
        case GET_ALL_FAVOURITE_PROPERTIES:
            return {
                ...state,
                favourite:payload,
                loading:false,
            };
        case GET_ALL_REPORTED_PROPERTIES:
          return {
            ...state,
            reported:payload,
            loading:false,
        };
        default:
            return state;
    }
  }

  export default getFavouritePropertiesReducer;